import { stepinContentInstance } from '@/apis/types/stepinContent';
import { CountryCode } from '@/app/[locale]/business/account/create/countryOptions';

const { GET } = stepinContentInstance;

export const refreshGeneralUserInfo = async () => {
	const { data, error, response } = await GET('/user');
	if (data) {
		const userInfo = data.data;
		// localStorage.setItem("generalUserInfo", JSON.stringify(userInfo));
		return userInfo;
	}
	console.error('[refreshGeneralUserInfo] API 실패:', {
		status: response?.status,
		error,
	});
	throw new Error(`유저 정보를 불러오는데 실패했습니다. (status: ${response?.status})`);
};

export const getBusinessUserInfo = async ({ businessAccountId }: { businessAccountId: string }) => {
	const { data, error, response } = await GET('/user', {
		headers: {
			BUSINESS: businessAccountId,
		},
	});
	if (data) {
		const userInfo = data;
		// localStorage.setItem("businessUserInfo", JSON.stringify(userInfo));
		return userInfo;
	}
	console.error('[getBusinessUserInfo] API 실패:', {
		businessAccountId,
		status: response?.status,
		error,
	});
	throw new Error(
		`비즈니스 유저 정보를 불러오는데 실패했습니다. (businessId: ${businessAccountId}, status: ${response?.status})`
	);
};

export const getMainTournamentList = async () => {
	const res = await GET('/v2/tournament/main');
	return res;
};

export const nationValid = async (nation: CountryCode | string) => {
	const res = await GET('/nation', {
		params: {
			query: {
				nationCode: nation,
			},
		},
	});
	return res;
};

export const tournamentNation = async (tournamentId: string) => {
	const { data, error } = await GET('/v2/tournament/{tournamentId}/rounds', {
		params: {
			path: {
				tournamentId: tournamentId,
			},
		},
	});

	if (data && data.data?.rounds.length === 0) {
		throw { error };
	}
	if (data) return data.data;

	if (error) throw error;
};

export async function getRoundData(id: string) {
	const { data, error } = await GET('/v2/tournament/{tournamentId}/rounds', {
		params: {
			path: {
				tournamentId: id,
			},
		},
	});

	if (data && data.data?.rounds.length === 0) throw { error };
	if (data) return data.data;

	if (error) throw error;
}
